<template>
  <v-col cols="12">
    <v-card-text>
      <v-btn @click="setupListeners()">listen</v-btn>
      <v-btn @click="registerProducts()">register</v-btn>
      <v-btn @click="restore()">restore</v-btn>
      <v-btn @click="ready()">ready</v-btn>
      <v-btn
        x-large
        @click.stop="
          () => {
            log('clearing...');
            messages = [];
          }
        "
        >clear</v-btn
      >
    </v-card-text>
    <v-card-text>
      Gems: {{ gems }} <br />
      Pro: {{ isPro }}
    </v-card-text>

    <v-card v-if="messages && messages.length > 0">
      <v-card-text
        v-html="message.msg"
        :class="'mb-4 ' + message.color"
        v-for="(message, idx) in messages"
        :key="idx"
      >
        <v-divider class="mt-4"></v-divider>
      </v-card-text>
    </v-card>

    <v-card class="black darken-4" v-if="products && products.length > 0">
      <v-card-text v-for="p in products" :key="p.id">
        {{ p.title ? p.title : p.id }}
        <p>{{ p.description }}</p>
        <v-btn @click.stop="purchase(p.id)"
          >buy ({{ p.price }} {{ p.currency }})</v-btn
        >
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
const PRODUCT_PRO_KEY = "vikarn_test_pro";
const PRODUCT_GEMS_KEY = "vikarn_test_gems";
import { InAppPurchase2 } from "@ionic-native/in-app-purchase-2/ngx";
//@awesome-cordova-plugins/in-app-purchase-2
const iap = new InAppPurchase2();
import { axios } from "@/plugins/axios";
import bus from "@/bus";
export default {
  name: "iap",
  components: {},
  data() {
    return {
      isPro: false,
      gems: 0,
      products: [],
      messages: [],
      registered: false,
    };
  },
  computed: {
    // store: iap,
    // store: InAppPurchase2,
  },
  methods: {
    log(msg, type) {
      let color = "";
      type = type ? type.toLowerCase() : "info";

      switch (type) {
        case "error":
          color = " red darken-4 white--text ";
          break;

        case "success":
          color = " green darken-2 white--text ";
          break;
        case "warn":
          color = " orange darken-2 white--text ";
          break;
        case "warn":
          color = " blue white--text ";
          break;
        default:
          color = " " + type + " ";
          break;
      }

      console.log(type, msg);
      this.messages.unshift({ color, msg });
    },
    purchase(product) {
      iap.order(product).then(
        (p) => {
          // Purchase in progress!
          this.log(`purchasing: ${p.id}`, "cyan");
        },
        (e) => {
          this.log(`Failed to purchase: ${e}`, "error");
        }
      );
    },
    restore() {
      this.log("restoring....");
      iap.refresh();
    },

    // registerProducts should only be called once in app cycle
    registerProducts() {
      iap.register({
        id: PRODUCT_GEMS_KEY,
        type: iap.CONSUMABLE,
      });

      iap.register({
        id: PRODUCT_PRO_KEY,
        type: iap.NON_CONSUMABLE,
      });
      this.registered = true;
      iap.refresh();
    },
    setupListeners() {
      // General query to all products
      iap
        .when("product")
        .approved((p) => {
          // Handle the product deliverable
          if (p.id === PRODUCT_PRO_KEY) {
            this.isPro = true;
          } else if (p.id === PRODUCT_GEMS_KEY) {
            this.gems += 100;
          }

          this.log(JSON.stringify(p.id), "indigo");
          return p.verify();
        })
        .verified((p) => p.finish());

      // Specific query for one ID
      // iap.when(PRODUCT_PRO_KEY).owned((p) => {
      //   this.isPro = true;
      // });
    },
    ready() {
      iap.ready(() => {
        this.log(
          JSON.stringify({ productscount: iap.products.length }),
          "brown"
        );
        this.products = iap.products;
      });
    },
  },
  beforeCreate() {},
  mounted() {
    // Only for debugging!
    iap.verbosity = iap.DEBUG;
    this.registerProducts();

    this.setupListeners();
    // Get the real product information
    setTimeout(() => {
      this.ready();
    }, 1000);
  },
};
</script>

